// extracted by mini-css-extract-plugin
export default {"select":"TreatmentsPage_select__phXUT"};